var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ ycc_container: !_vm.isMobile }},[_c('main-header'),_c('div',{staticClass:"bg-gray-50"},[_c('router-view')],1),_c('main-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }